/* tslint:disable */
/* eslint-disable */
export enum CurveType {
  Linear = 'LINEAR',
  Manual = 'MANUAL',
  Exponential = 'EXPONENTIAL',
}
